angular.module("kareo.ui.shared.directives.patient-payment-data", [])
.service 'PatientPaymentData', [
  '$http', '$location', ($http, $location) ->

    defaultUrl = "/payments-ui/api/PatientPayment"

    getDefaultUrl: ->
      defaultUrl

    getSettings: ->
      url = "#{defaultUrl}/settings"
      $http.get(url)

    # New redirect URLs must also be configured in Stripe
    stripeRegistration: ->
      redirect = encodeURIComponent($location.path())
      url = "#{defaultUrl}/stripe-registration?redirect=#{redirect}"
      $http.post(url)

    togglePayments: (enable) ->
      url = "#{defaultUrl}/toggle-payments/#{enable}"
      $http.post(url)

    # toggle credit card authorization form in the intake selection
    toggleIntakeCCAuthForm: (enable) ->
      url = "#{defaultUrl}/toggle-intake-credit-card-auth-form/#{enable}"
      $http.post(url)

    registerPayments : () ->
      url = "#{defaultUrl}/register-payments"
      $http.post(url)

    registerStripe : (code) ->
      url = "#{defaultUrl}/register-stripe/#{code}"
      $http.post(url).then((response) ->
        data = response.data
        if(data=='true')
          return true
        return data
      )

    makePayment: (paymentObj) ->
      url = "#{defaultUrl}/payment"
      $http.post(url, paymentObj)

    sendReceipt: (receiptObj) ->
      url = "#{defaultUrl}/receipt"
      $http.post(url, receiptObj)

    sendPatientPayReceipt: (receiptObj) ->
      url = "#{defaultUrl}/receipt-tebra-pay"
      $http.post(url, receiptObj)

    getFormData: (patientId) ->
      url = "#{defaultUrl}/form-data/#{patientId}"
      $http.get(url)

    recordHostedPayments: (paymentObj) ->
      url = "#{defaultUrl}/hosted-payments";
      $http.post(url, paymentObj);
]
